var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPickColor = function SvgPickColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 16 18",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m9.105 2.391 4.421 4.174m-4.2 2.783H2.99m11.348-7.722a2.317 2.317 0 0 0-3.169 0L3.063 9.278c-.663.626-.81 1.6-.442 2.365 0 0-.074 0-.074.07l-.663.626a.726.726 0 0 0 0 1.044.836.836 0 0 0 1.106 0l.663-.627s0-.069.073-.069c.81.348 1.842.209 2.506-.417l8.105-7.653c.884-.834.884-2.156 0-2.99M3.21 15.956c0 .557-.516 1.044-1.106 1.044S1 16.513 1 15.957c0-.557 1.105-1.74 1.105-1.74s1.106 1.183 1.106 1.74"
  })));
};
export default SvgPickColor;